module.exports = __webpack_public_path__ + "static/img_0836-51adba7cc7d686559357eeb35d75f90e.webp";